import React, { FC, ReactNode } from "react";
import * as Sentry from "@sentry/react";
import { useKeycloak } from "@react-keycloak/web";
import { UnauthenticatedPlaceholder } from "../components/layout/UnauthenticatedPlaceholder";
import { AuthenticatedLayout, NavigationDefinition } from "../components/layout/AuthenticatedLayout";
import Keycloak from "keycloak-js";
import { ConfigInterface } from "../config";
import { GuestLayout } from "../components/layout/GuestLayout";
import { AuthProvider as VentumAuthProvider } from "@ventumsoftware/react-toolkit"
import { NavigateFunction } from "react-router-dom";

export const AuthProvider: FC<{ children: ReactNode, authClient: Keycloak, isGuestRoute: () => boolean }> = ({ children, isGuestRoute, authClient }) => {
  if (isGuestRoute()) {
    return <GuestLayout>{children}</GuestLayout>;
  }
  return <VentumAuthProvider keycloak={authClient} onAuthFailure={(requestFailed) => {
    Sentry.captureMessage(requestFailed ? "Token refresh request failed (network)" : "Session expired - redirecting to login", { level: "warning", tags: { requestFailed } });
  }}>
    {children}
  </VentumAuthProvider>
}
export const AuthMiddleware: FC<{ children: React.ReactNode, config: ConfigInterface, navigation: NavigationDefinition, navigate: NavigateFunction, allowedRoles: string[], appTitle: string, appSubTitle: string, image: string | null }> = (props) => {
  const { keycloak } = useKeycloak()

  if (!keycloak.authenticated) {
    return <UnauthenticatedPlaceholder />
  }
  const roles = keycloak?.realmAccess?.roles ?? []
  if (!props.allowedRoles.some(role => roles.includes(role))) {
    return <UnauthenticatedPlaceholder reason={"Je hebt geen toegang tot deze applicatie"} />
  }
  return <AuthenticatedLayout navigation={props.navigation} navigate={props.navigate} title={props.appTitle} subtitle={props.appSubTitle} image={props.image}>{props.children}</AuthenticatedLayout>
}

